import asJSONLDSnippet from './asJSONLDSnippet';

export default asJSONLDSnippet(({name, url, searchUrl}) => ({
  '@context': 'http://schema.org/',
  '@type': 'WebSite',
  name: name,
  url: url,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${searchUrl}{search_query}`,
    'query-input': 'required name=search_query'
  }
}));



// WEBPACK FOOTER //
// ./components/JSON-LD/JSONLDWebsite.js